import React from 'react';
import { Link } from 'react-scroll';
import backgroundImage from '../images/pexels-amina-filkins-5560553.jpg';

function MainSection() {
  return (
    <div
      id='top'
      className='section main lp-normal'
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: '0',
          left: '0',
          right: '0',
          height: '80%',
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          zIndex: '-1',
        }}
      />
      <div className='container-2 w-container'>
        <h1 className='main-heading smaller-bottom-margin'>
          BetroffenenrechtSanfragen
          <br />
        </h1>
        <h1 className='main-heading smaller-bottom-margin'>
          effizient bearbeiten
          <br />
        </h1>
        <div className='front-page-subtext'>
          <h2 className='heading-17a'>
            Ihr Unternehmen erhält DSGVO Betroffenenrechtsanfragen? Unser
            Online-Tool zur Automatisierung von Datenschutzprozessen hilft
            Ihnen, die Anfragen schnell, mit wenig Aufwand und gesetzeskonform
            zu bearbeiten.
            <br />
          </h2>
          <Link
            to='featuresEnterprises'
            smooth={true}
            duration={500}
            className='link-block-green w-inline-block'
          >
            <div className='text-block-5'>Mehr erfahren &gt;&gt;</div>
          </Link>
        </div>
        <div className='div-block-10 w-clearfix'>
          <Link
            to='pricing'
            smooth={true}
            duration={500}
            className='button hollow'
          >
            30 Tage kostenlos ausprobieren!
          </Link>
        </div>
      </div>
    </div>
  );
}

export default MainSection;
